angular.module("datiFinanziari.components", []).component("datiFinanziari", {
  templateUrl: "ng/components/richiestaPreventivo/datiFinanziari/datiFinanziari.view.html",
  bindings: {
    model: "=",
    amount: "<",
    exportValidityDatiFinanziari: "&",
    initialTabIndex: "=",
    percentagesResetted: "&"
  },
  controllerAs: "datiFinanziariCtrl",
  controller: function DatiFinanziari(
    FileUploader,
    $simulationService,
    $configService,
    $rootScope,
    $timeout,
    $typeDomainService,
    $portalService,
    $financialApiService,
    verifyUniqueService,
    $download
  ) {
    var self = this;

    self.$onInit = function () {

      self.supportModel = {
        dropdown: {
          listAssicurazione: []
        },
        initialIndex: 0,
        indexAnticipo: 0,
        ndexRiscatto: 0
      }

      self.supportModel.initialIndex = self.initialTabIndex || 0;
      self.supportModel.indexAnticipo = self.supportModel.initialIndex + 1;
      self.supportModel.indexRiscatto = self.supportModel.initialIndex + 3;

      self.model.preventivo.pianoFinanziario.anticipo.percentuale = null;
      self.model.preventivo.pianoFinanziario.riscatto.percentuale = null;
      self.loadingStatus = {
        uploading: false
      };
      recuperaId();
    }

    self.$onChanges = function (changed) {
      if (changed && changed.amount && changed.amount.currentValue) {
        if (self.model.preventivo.pianoFinanziario.anticipo.percentuale != 0 ||
          self.model.preventivo.pianoFinanziario.riscatto.percentuale != 0) {
          self.percentagesResetted({
            showAlert: true
          })
        } else {
          self.percentagesResetted({
            showAlert: false
          })
        }
        self.model.preventivo.pianoFinanziario.anticipo.percentuale = 0;
        self.model.preventivo.pianoFinanziario.riscatto.percentuale = 0;
      }
    }

    self.handleChange = function (property) {
      if (property === 'durataMesi' ||
        property === 'noteAlba' || property === 'tipoPolizzaRichiesta') {
        if (self.model.preventivo.pianoFinanziario.durataMesi &&
          self.model.preventivo.noteAlba && self.model.preventivo.tipoPolizzaRichiesta) {
          self.exportValidityDatiFinanziari({
            validity: true
          })
        } else {
          self.exportValidityDatiFinanziari({
            validity: false
          })
        }
      }
    }

    self.handleFinancialStructureChange = function (property, value) {
      if (property == 'anticipoImportPerc') {
        self.model.preventivo.pianoFinanziario.anticipo.importo = value.currency;
        self.model.preventivo.pianoFinanziario.anticipo.percentuale = value.percent;
        self.anticipoChanged = true;
      }

      if (property == 'riscatto') {
        self.model.preventivo.pianoFinanziario.riscatto.importo = value.currency;
        self.model.preventivo.pianoFinanziario.riscatto.percentuale = value.percent;
        self.riscattoChanged = true;
      }
      if (self.anticipoChanged && self.riscattoChanged &&
        self.model.preventivo.pianoFinanziario.anticipo.importo != 0 &&
        self.model.preventivo.pianoFinanziario.anticipo.percentuale != 0 &&
        self.model.preventivo.pianoFinanziario.riscatto.importo != 0 &&
        self.model.preventivo.pianoFinanziario.riscatto.percentuale != 0) {
        self.percentagesResetted({
          showAlert: false
        })
      }
    }

    self.check = function (el) {
      el.isSelected = !el.isSelected;

    };

    // inizio procedura upload file
    self.uploader = new FileUploader({
      url: "",
      headers: {
        "Access-Control-Allow-Origin": "*",
        Token: "Bearer " + ($configService.getAppConfig().token || "no-token"),
        "App-Name": $rootScope.portalName
      }
    });

    self.uploadDataFunc = function (item, index) {
      var document =
        arguments.length > 3 && arguments[3] !== undefined ?
          arguments[3] :
          false;
      if (item) {
        self.uploadData = item;
      }
      self.uploadDocumenti = document;

    };



    self.finalUpload = function () {
      console.log("calling finalUpload");
      self.folderPath = "" + new Date().getTime();
      var url = $configService.getAppConfig().url +
        "/uni/upload/service-infos/" +
        encodeURIComponent(self.model.anno) +
        "/" +
        encodeURIComponent(self.model.numero) +
        "/FINANCIAL";

      for (var int = 0; int < self.uploader.queue.length; int++) {
        self.uploader.queue[int].url = url;
      }
      self.loadingStatus.uploading = true;
      //self.uploader.uploadAll();
      var file = document.querySelector("#uploadInput_document").files[0];

      self.disabledButtonUpload = true;
      var reader = new FileReader();
      reader.onload = function (event) {
        jQuery("#uploadInput_document").val("");
        var formData = new FormData();
        appendToForm(formData, "file", file);
        appendToForm(formData, "type", 'FINANCIAL_DEROGHE');
        appendToForm(formData, "cdDoc", 'GENP');
        appendToForm(formData, "filename", file.name);
        appendToForm(formData, "idPratica", self.leasindDataId);

        $financialApiService.uploadDocOnRichPrev(formData)
          .then(function (response) {
            if (response.success) {
              $timeout(function () {
                var tmp = {
                  filename: file.name,
                  id: response.id,
                  cdDoc: 'GENP',
                  status: "1",
                  downloadKey: response.downloadKey
                }

                self.visualProgBarDoc = false;
                self.model.preventivo.allegati.push(tmp);

              }, 4000);

            } else {
              self.visualProgBarDoc = false;
              $rootScope.$broadcast("addAlert", {
                text: "ERROR_UPLOADING_FILE"
              })
            }
            self.disabledButtonUpload = false;

          })
          .catch(function (error) {
            self.visualProgBarDoc = false;
            self.disabledButtonUpload = false;
          })
      };
      if (file) {
        reader.readAsArrayBuffer(file);
      }
    };

    self.uploader.onAfterAddingFile = function (fileItem) {
      console.log("fileItem", fileItem);
      self.progresso = 0;
      if (fileItem.file.size > 26214400) {
        $rootScope.$broadcast("addAlert", {
          text: "MAXIMUM_FILE_SIZE_EXCEEDED"
        });
        fileItem.remove();
        jQuery("#uploadInput_document").val("");
      }
      var fileName = fileItem.file.name;
      if (
        fileName.toLowerCase().indexOf(".png") > -1 ||
        fileName.toLowerCase().indexOf(".jpg") > -1 ||
        fileName.toLowerCase().indexOf(".jpeg") > -1 ||
        fileName.toLowerCase().indexOf(".tiff") > -1 ||
        fileName.toLowerCase().indexOf(".pdf") > -1 ||
        fileName.toLowerCase().indexOf(".msg") > -1 ||
        fileName.toLowerCase().indexOf(".eml") > -1 ||
        fileName.toLowerCase().indexOf(".zip") > -1 ||
        fileName.toLowerCase().indexOf(".p7m") > -1
      ) {

        self.uploader.queue[0].progress = 100;

        self.visualProgBarDoc = true;

        $timeout(function () {
          self.progresso = 100;
        }, 500);
      } else {
        fileItem.remove();
        jQuery("#uploadInput_document").val("");
        $rootScope.$broadcast("addAlert", {
          text: "FORMAT_NOT_SUPPORTED"
        });

      }
    };

    //altre funzioni di upload
    self.generateDownloadLink = function (file) {
      var url =
        "/uni/downloadDocRichPrev/service-infos/?downloadKey=" +
        encodeURIComponent(file.downloadKey)

      $download.getGenericDownload(url)
        .then(function (response) {
          console.log(response);
        })

    }
    self.uploader.onWhenAddingFileFailed = function (
      item,
      filter,
      options
    ) {
      console.info("onWhenAddingFileFailed", item, filter, options);
    };

    self.uploader.onAfterAddingFile = function (fileItem) {
      console.log("fileItem", fileItem);
      self.progresso = 0;
      if (fileItem.file.size > 26214400) {
        $rootScope.$broadcast("addAlert", {
          text: "MAXIMUM_FILE_SIZE_EXCEEDED"
        });
        fileItem.remove();
        jQuery("#uploadInput_document").val("");
      }
      var fileName = fileItem.file.name;
      if (
        fileName.toLowerCase().indexOf(".png") > -1 ||
        fileName.toLowerCase().indexOf(".jpg") > -1 ||
        fileName.toLowerCase().indexOf(".jpeg") > -1 ||
        fileName.toLowerCase().indexOf(".tiff") > -1 ||
        fileName.toLowerCase().indexOf(".pdf") > -1 ||
        fileName.toLowerCase().indexOf(".msg") > -1 ||
        fileName.toLowerCase().indexOf(".eml") > -1 ||
        fileName.toLowerCase().indexOf(".zip") > -1 ||
        fileName.toLowerCase().indexOf(".p7m") > -1
      ) {

        self.uploader.queue[0].progress = 100;

        self.visualProgBarDoc = true;

        $timeout(function () {
          self.progresso = 100;
        }, 500);
      } else {
        fileItem.remove();
        jQuery("#uploadInput_document").val("");
        $rootScope.$broadcast("addAlert", {
          text: "FORMAT_NOT_SUPPORTED"
        });
      }
    };

    self.uploader.onAfterAddingAll = function (addedFileItems) {
      console.info("onAfterAddingAll", addedFileItems);
      self.finalUpload(self.uploadData);
    };

    self.uploader.onBeforeUploadItem = function (item) {

      item.file.name = window.encodeURIComponent(item.file.name);
      item.headers["Token"] = "Bearer " + $configService.getAppConfig().token;

    };

    self.uploader.onProgressItem = function (fileItem, progress) {
      self.uploadCompleted = false;
    };

    self.uploader.onProgressAll = function (progress) { };

    self.uploader.onSuccessItem = function (
      fileItem,
      response,
      status,
      headers
    ) {
      self.loadingStatus.uploading = false;
    };

    self.uploader.onErrorItem = function (
      fileItem,
      response,
      status,
      headers
    ) {
      console.info("onErrorItem", fileItem, response, status, headers);
      self.loadingStatus.uploading = false;
      jQuery("#uploadInput_document").val("");

      $rootScope.$broadcast("addAlert", {
        text: "ERROR_UPLOADING_FILE"
      });

      $timeout(function () {

        self.visualProgBarDoc = false;


      }, 4000);

      fileItem.remove();
      jQuery("#uploadInput_document").val("");

    };

    self.uploader.onCancelItem = function (
      fileItem,
      response,
      status,
      headers
    ) {
      console.log(status);
    };

    self.uploader.onCompleteItem = function (
      fileItem,
      response,
      status,
      headers
    ) {
      console.info("onCompleteItem", fileItem, response, status, headers);
      if (response && response.uploadFileServicePojo && response.uploadFileServicePojo.success) {
        self.uploadOk = true;
        console.log(fileItem);

        var document = {
          fileStatus: null,
          isSelected: false,
          nameFile: response.uploadFileServicePojo.fileName,
          uuid: "",
          errorMessage: "",
          documentClass: ""
        };

        self.listOfFilesUpload = response.metadataUniUpload.uploadedfile
          .sort(function (a, b) {
            if (a.codiceDocNSIL > b.codiceDocNSIL) {
              return 1
            } else {
              return -1
            }
          });
      }
      self.uploader.queue = [];

      $timeout(function () {

        self.visualProgBarDoc = false;


      }, 4000);
      jQuery("#uploadInput_document").val("");


    };

    self.uploader.onCompleteAll = function () {
      console.info("onCompleteAll");
      self.uploadCompleted = true;
    };

    self.uploader.onSuccessItem = function (fileItem, response, status, headers) {
      self.uploading = false;
    };

    self.deleteDocument = function () {
      self.visualProgBarDoc = true;
      var temp = self.model.preventivo.allegati
        .filter(function (element) {
          return element.isSelected == true;
        })

      temp.forEach(function (element) {


        $simulationService.deleteChecklistFileDigital(element.id)
          .then(function (response) {

            self.progresso = 0;
            if (response.success) {
              $timeout(function () {
                self.model.preventivo.allegati = self.model.preventivo.allegati
                  .filter(function (elem) {
                    return elem.isSelected != true;
                  })
              }, 3500);
              $timeout(function () {
                self.visualProgBarDoc = false;
              }, 4000);
            } else {
              self.visualProgBarDoc = false;
            }
          })
          .catch(function (error) {
            $rootScope.$broadcast('addAlert', {
              text: 'ERROR_TEC'
            });
          });

      });
    }

    self.enabledTrash = function () {

      return self.model.preventivo.allegati.some(function (element) {
        return element.isSelected == true;
      })
    }

    var recuperaId = function () {
      verifyUniqueService.getGeneric()
        .then(function (response) {
          if (response.success) {
            self.leasindDataId = response.id;
          }
        })
        .catch(function (error) {
          console.log(error);
        })
    }

  }
})